import "./App.css";

import RouteIndex from "./Routes/RouteIndex";
import ErrorHandler from "./Common/ErrorHandler/ErrorHandler";
import { ToastContainer } from "react-toastify";
import { BrowserRouter, useNavigate } from "react-router-dom";
import AuthInitializer from "./Common/AuthInitializer";
import { useDispatch } from "react-redux";
import { setAccessToken, setIsAuthenticated, setRefreshToken, setUserData } from "./Redux/Slices/Pages/Auth/LoginSlice";
import { useEffect } from "react";

function App() {
  const dispatch =useDispatch();

  useEffect(() => {
  const handleStorageChange = (event) => {
    if (event.key === "logout") {
      // Perform local logout logic
      dispatch(setIsAuthenticated(false));
      dispatch(setAccessToken(null));
      dispatch(setUserData(null));
      dispatch(setRefreshToken(null));
      sessionStorage.clear();

      // Optionally redirect
      window.location.href = "/login";
    }
  };

  window.addEventListener("storage", handleStorageChange);

  return () => {
    window.removeEventListener("storage", handleStorageChange);
  };
}, [dispatch]);

  
  return (
  <BrowserRouter>
  <AuthInitializer/>
      <RouteIndex />
      {/* <ErrorHandler/> */}
      <ToastContainer/>
  </BrowserRouter>
    
  );
}

export default App;
